import { URLS } from '@/config/constants'

/**
 * Global Alert Configuration
 *
 * This file contains all alert configurations that can be displayed in the GlobalAlertBanner.
 * When you want to show a new alert to all users, create a new entry with a unique ID.
 *
 * Each alert should have the following properties:
 * - id: Unique identifier for the alert. Change this when you want all users to see the alert again.
 * - title: Short title for the alert
 * - message: Main alert message content
 * - color: Color theme (info, warning, error, success)
 * - icon: Material Design icon name
 * - actionText: (Optional) Text for action button
 * - action: (Optional) Function to execute when action button is clicked
 * - dismissible: Whether the alert can be dismissed for the current session
 * - allowDontShowAgain: Whether users can permanently hide this alert
 */

export const ALERTS = {
  ACTIONS_MARCH_18_RELEASE: {
    id: 'actions-march-18-release',
    title: 'Quick Actions Now Available',
    message:
      'Click the <strong>Actions</strong> button to start, and review progress in the <strong>Actions</strong> tab.',
    color: 'orange',
    icon: 'mdi-new-box',
    actionText: 'Learn More',
    dismissible: true,
    allowDontShowAgain: true,
    action: () => window.open(URLS.changeLog, '_blank')
  }
}

/**
 * Get the current active alert to display
 *
 * You can modify this function to control which alert is shown based on various conditions,
 * such as user role, date ranges, feature flags, etc.
 *
 * @returns {Object|null} The alert to display or null if no alert should be shown
 */
export function getCurrentAlert() {
  // Example: You could add logic here to determine which alert to show
  // For now, we'll just return the NEW_FEATURE alert
  return null

  // Example of conditional alert selection:
  // const currentDate = new Date()
  // if (currentDate < new Date('2025-03-20')) {
  //   return ALERTS.MAINTENANCE_ALERT
  // } else {
  //   return ALERTS.NEW_FEATURE_MARCH_2025
  // }

  // Return null to show no alert
  // return null
}

/**
 * Handle alert action
 *
 * @param {Object} alert The alert object
 */
export function handleAlertAction(alert) {
  if (alert && alert.action) {
    alert.action()
  }
}
